export { default } from "./PhotoPlaceholder.jsx"
